import type { StrictPost } from '$lib/types'

export const outcomesMeta: StrictPost = {
	title: 'AI Outcomes',
	slug: 'outcomes',
	description: 'What will happen if we continue to build AI?',
	date: '2023-08-24',
	categories: []
}
